'use client';

import type {FC} from 'react';
import {useLiveQuery} from 'next-sanity/preview';
import {internalLinkToHref} from 'utils';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {CallToActionSchema} from 'components/call-to-action/schema';

import {CallToActionRender} from './render';

interface Props {
	callToAction: CallToActionSchema;
}

export const CallToActionDraft: FC<Props> = ({callToAction}) => {
	const [reference, loading] = useLiveQuery<LinkReferencesQueryResult>(
		null,
		LINK_REFERENCES_QUERY,
		{
			id: callToAction.reference?._ref ?? '',
		},
	);

	if (loading) {
		return (
			<CallToActionRender
				targetBlank={callToAction.targetBlank}
				text="Loading..."
				color="primary"
			/>
		);
	}

	return (
		<CallToActionRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={callToAction.targetBlank}
			text={callToAction.text ?? ''}
			color={callToAction.color ?? 'primary'}
		/>
	);
};
